/** Public entry point for browser Push permission, persistence, and delivery. */
import type { SupabaseClient } from '@supabase/supabase-js';

import type { Database } from '../database.types.js';
import { createBrowserPush } from './internal/browserPush.js';
import { createSupabasePushRemote } from './internal/supabasePushRemote.js';
import { createSupabasePushSubscriptionRepository } from './internal/supabaseSubscriptions.js';
import { createPushNotifications } from './pushNotifications.js';

export type { PushNotifications, PushSendResult, PushStatus } from './pushNotifications.js';

export const createBrowserPushNotifications = (client: SupabaseClient<Database>) =>
  createPushNotifications(
    createBrowserPush(),
    createSupabasePushSubscriptionRepository(client),
    createSupabasePushRemote(client),
  );
